import React from 'react'
import MainNavigation from '../components/Navigation';

export default function Games() {
  return (
    <div>
      <MainNavigation />
      <div>Games</div>
    </div>
  );
}
